import cloneObject from '@/helpers/cloneObject';

const filter =
  (instance) =>
  ({ target }) =>
    target.call(instance);

const action =
  (instance, settings) =>
  ({ migrate }) => {
    migrate.call(instance, settings);
  };

const isModal = (instance) => {
  const { instances, settingsInstance, data } = instance;

  return (
    (instances && instances[settingsInstance]?.module === 'ModalSettings') ||
    /Popup$/.test(data?.module)
  );
};

export default (migrations) => (baseInstance, settings) => {
  if (!baseInstance) {
    return {};
  }
  if (!baseInstance.data && !isModal(baseInstance)) {
    return baseInstance;
  }

  const instance = cloneObject(baseInstance);

  migrations.filter(filter(instance)).forEach(action(instance, settings));

  return instance;
};
